import { render, staticRenderFns } from "./PopupAddEditTermsAndConditions.vue?vue&type=template&id=9a37864e&scoped=true"
import script from "./PopupAddEditTermsAndConditions.vue?vue&type=script&lang=js"
export * from "./PopupAddEditTermsAndConditions.vue?vue&type=script&lang=js"
import style0 from "./PopupAddEditTermsAndConditions.vue?vue&type=style&index=0&id=9a37864e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a37864e",
  null
  
)

export default component.exports